const APIUrl: string = import.meta.env.VITE_APP_API_BASE_URL;
const AppName: string = import.meta.env.VITE_APP_NAME;
const RedirectUri: string = import.meta.env.VITE_APP_REDIRECT_URI;
const FEClientId: string = import.meta.env.VITE_APP_FE_CLIENT_ID;
const APIAuthScope: string = import.meta.env.VITE_APP_API_SCOPE;
const AppEnv: string = import.meta.env.VITE_APP_ENV;
const Authority: string = import.meta.env.VITE_APP_AUTHORITY;
const ApplicationInsights: string = import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING;

export default { FEClientId, Authority, APIUrl, APIAuthScope, RedirectUri, AppEnv, ApplicationInsights };